/**
 * Clinical Research Video - Popup Handler
 * Handles popup interactions for enzyme level information
 */

(function () {
  /**
   * Initialize popup functionality
   */
  function initializePopups() {
    const overlay = document.querySelector(".enzyme-popup-overlay");
    const infoButtons = document.querySelectorAll(".enzyme-info-btn");
    const popups = document.querySelectorAll(".enzyme-popup");
    const closeBtns = document.querySelectorAll(".enzyme-popup-close");

    if (!overlay || !infoButtons.length || !popups.length) {
      return;
    }

    // Open popup on info button click
    infoButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const popupLink = btn.getAttribute("data-popup-link");

        if (!popupLink) {
          console.warn("Button missing data-popup-link attribute");
          return;
        }

        // Find popup that matches this button's popup link ID
        const targetPopup = Array.from(popups).find((popup) => {
          const popupLinkAttr = popup.getAttribute("data-popup-link");
          return popupLinkAttr === popupLink;
        });

        if (targetPopup && overlay) {
          overlay.classList.remove("hidden");
          targetPopup.classList.remove("hidden");

          // Focus on the close button for accessibility
          const closeBtn = targetPopup.querySelector(".enzyme-popup-close");
          if (closeBtn) {
            closeBtn.focus();
          }
        } else if (!targetPopup) {
          console.warn(`No popup found with data-popup-link="${popupLink}"`);
        }
      });
    });

    // Close popup on overlay click
    if (overlay) {
      overlay.addEventListener("click", () => {
        closeAllPopups(overlay, popups, infoButtons);
      });
    }

    // Close popup on close button click
    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        closeAllPopups(overlay, popups, infoButtons);
      });
    });

    // Close popup on ESC key
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        overlay &&
        !overlay.classList.contains("hidden")
      ) {
        closeAllPopups(overlay, popups, infoButtons);
      }
    });
  }

  /**
   * Close all popups and overlay, return focus to trigger button
   * @param {Element} overlay - The popup overlay element
   * @param {NodeListOf<Element>} popups - All popup elements
   * @param {NodeListOf<Element>} buttons - All trigger buttons
   */
  function closeAllPopups(overlay, popups, buttons) {
    if (overlay) {
      overlay.classList.add("hidden");
    }

    // Find which popup was open and return focus to its trigger
    popups.forEach((popup) => {
      if (!popup.classList.contains("hidden")) {
        const popupLink = popup.getAttribute("data-popup-link");
        popup.classList.add("hidden");

        // Return focus to the button that opened this popup
        const triggerBtn = Array.from(buttons).find(
          (btn) => btn.getAttribute("data-popup-link") === popupLink
        );
        if (triggerBtn) {
          triggerBtn.focus();
        }
      }
    });
  }

  // Initialize on DOM load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializePopups();
    });
  } else {
    // DOM already loaded
    initializePopups();
  }

  // Re-initialize when Shopify section is reloaded in theme editor
  if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      initializePopups();
    });
  }
})();
